export default function completeTask(params) {
    this.dsClear();
    this.dsAdd('set', params.prefix + '/fields/status/value', params.status);
    this.dsAdd('set', params.prefix + '/changes/fields/status', params.status);
    this.dsProcess();
    params.canSave = true;
    this.saveRecord(params);
}
